import React from "react";
import style from "./Clients.module.css";
export default function Clients() {
  return (
    <div className={style.mainContainer}>
      <div>
        <p className={style.heading}>
          OUR <strong>AWESOME</strong> CLIENTS
        </p>
      </div>
      <div className={style.imagesMainDiv}>
        <div className={style.imageDiv}>
          <img
            alt="Advisor360"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/1.svg"
          ></img>
        </div>
        <div className={style.imageDiv}>
          <img
            alt="Travelliance"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/4.svg"
          ></img>
        </div>
        <div className={style.imageDiv}>
          <img
            alt="Stitch"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/3.svg"
          ></img>
        </div>
        <div className={style.imageDiv}>
          <img
            alt="QServ"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/2.svg"
          ></img>
        </div>
        <div className={style.imageDiv}>
          <img
            alt="TabarNapp"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/5.svg"
          ></img>
        </div>
        <div className={style.imageDiv}>
          <img
            alt="Practimyze"
            className={style.figure}
            src="https://invozone.com/wp-content/uploads/2020/04/6.svg"
          ></img>
        </div>
      </div>
    </div>
  );
}
